var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('basic-select',{attrs:{"options":_vm.options,"isError":_vm.isError,"reload":_vm.reload,"isDisabled":_vm.isDisabled,"selected-option":_vm.item,"placeholder":_vm.placeholder,"robot":"sel-catalogtype"},on:{"select":_vm.onSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }